import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import i18n from "locale";

import "./unexpected-error.css";

const UnexpectedError = ({
  errorMessage,
  onClose,
  className = undefined,
  testId = "unexpected-error",
  closeButtonTestId = "unexpected-close-btn"
}) => {
  const { t } = useTranslation();
  if (!errorMessage) return null;
  const displayMessage =
    typeof errorMessage === "string" && i18n.exists(errorMessage)
      ? t(errorMessage)
      : errorMessage;
  return (
    <div
      className={clsx(
        "alert alert-danger unexpected-error",
        onClose && "alert-dismissible",
        className
      )}
      data-testid={testId}
      role="alert"
    >
      <div className="unexpected-error-content">
        {displayMessage}
        {onClose && (
          <button
            type="button"
            className="btn-close"
            data-testid={closeButtonTestId}
            data-dismiss="alert"
            aria-label={t("generic:buttons.close")}
            onClick={onClose}
          ></button>
        )}
      </div>
    </div>
  );
};

UnexpectedError.propTypes = {
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onClose: PropTypes.func,
  className: PropTypes.string,
  testId: PropTypes.string,
  closeButtonTestId: PropTypes.string
};

export default UnexpectedError;
